<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 align-middle">
    <em class="fa fa-warning fa-lg text-warning"></em>
    <span class="font-bold text-warning pl-3" i18n="@@alertCSO">CSO: Contrôle Sanitaire Obligatoire</span>
  </div>
</div>


